import Swal from 'sweetalert2' 

import {
  ITEMS_FETCH_SUCCESS,
  CATEGORIES_FETCH_SUCCESS
} from './actionType';

export const fetchItemsSuccess = (payload) => {
  return {
    type: ITEMS_FETCH_SUCCESS,
    payload,
  }
}

export const fetchCategoriesSuccess = (payload) => {
  return {
    type: CATEGORIES_FETCH_SUCCESS,
    payload,
  }
}

export const fetchItems = () => {
  return (dispatch, getState) => {
    return fetch("https://aci-hardware.herokuapp.com/admin/all", {
      headers: {
        access_token: localStorage.getItem('access_token')}
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not OK");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        // setItems(data);
        dispatch(fetchItemsSuccess(data.data))
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation: ",
          error
        );
      });
  }
}

export const addProduct = (newProduct) => {
  return (dispatch, getState) => {
    newProduct.images = newProduct.images.filter(i => i.length > 0);
  
    return fetch("https://aci-hardware.herokuapp.com/admin/products/add", {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          access_token: localStorage.getItem('access_token')
        },
        body: JSON.stringify(newProduct)
      })
  }
}

export const deleteProduct = (id) => {
  return (dispatch, getState) => {
    return fetch(`https://aci-hardware.herokuapp.com/admin/products/${id}`,
      {
        method: 'DELETE',
        headers: {
          access_token: localStorage.getItem('access_token')
        }
      }).then(resp => {
        resp.json()
        dispatch(fetchItems())
        Swal.fire(
          'Data Deleted',
          'Successfully removed a product from the database.',
          'success'
        )
      })
      .catch(console.log)
  }
}

export const updateProduct = (id, newProduct) => {
  return(dispatch, getState) => {

    return fetch(`https://aci-hardware.herokuapp.com/admin/products/${id}`,
      {
        method: 'PUT',
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          access_token: localStorage.getItem('access_token')
        },
        body: JSON.stringify(newProduct)
      })
        .then(resp => resp.json())
        .then(data => {
          dispatch(fetchItems())
          Swal.fire(
            'Data Updated',
            'Successfully updated a product from the database.',
            'success'
          )
        })
        .catch(console.log)
  }
}

  export const fetchCategories = () => {
    return (dispatch, getState) => {
      return fetch("https://aci-hardware.herokuapp.com/admin/categories", {
        headers: {
          access_token: localStorage.getItem('access_token')
        }
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not OK");
          }
          return response.json();
        })
        .then((data) => {
          console.log(data)
          // setCategories(data)
          dispatch(fetchCategoriesSuccess(data.data))
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation",
            error
          )
        })
    }
  }

  export const addCategory = (newCategory) => {
    return (dispatch, getState) => {
      console.log(newCategory, '////')
      fetch("https://aci-hardware.herokuapp.com/admin/categories/add", {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          access_token: localStorage.getItem('access_token')
        },
        body: JSON.stringify({ name: newCategory })
      })
        .then(resp => {resp.json()
        if(!resp.ok){
          Swal.fire(
            'Data Added',
            'Successfully added a new category to the database.',
            'success'
          )
        }else{
          Swal.fire(
            'Data Added',
            'Successfully added a new category to the database.',
            'success'
          )
        }
       
      })
        .then(data => {
          console.log(data, "<<< ini data")
          dispatch(fetchCategories())
          
        })
        .catch(console.log)
    }
  }

  export const deleteCategory = (id) => {
    return (dispatch, getState) => {
      fetch(`https://aci-hardware.herokuapp.com/admin/categories/${id}`, {
        method: 'DELETE',
        headers: {
          access_token: localStorage.getItem('access_token')
        }
      }).then(resp => {
        resp.json()
        dispatch(fetchCategories())
        if(!resp.ok){
          Swal.fire(
            'Data Not Deleted',
            'Can not remove category because it is being used by a product',
            'error'
          )
        }else{
          Swal.fire(
            'Data Deleted',
            'Successfully deleted a category from the database.',
            'success'
          )
        }
        
      })
        .catch(console.log)
    }
  }

  export const updateCategory = (id, newCategory) => {
    return(dispatch, getState) => {

      return fetch(`https://aci-hardware.herokuapp.com/admin/categories/${id}`,
        {
          method: 'PATCH',
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            access_token: localStorage.getItem('access_token')
          },
          body: JSON.stringify(newCategory)
        })
          .then(resp => resp.json())
          .then(data => {
            console.log(data, "<<< ini data")
            dispatch(fetchCategories())
            Swal.fire(
              'Data Updated',
              'Successfully updated a category from the database.',
              'success'
            )
          })
          .catch(console.log)
    }
  }

  export const registerAdmin = (newAdmin) => {
    return (dispatch, getState) => {
      console.log(newAdmin)
      fetch("https://aci-hardware.herokuapp.com/admin/register-admin", {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          access_token: localStorage.getItem('access_token')
        },
        body: JSON.stringify(newAdmin)
      })
        .then(resp => {
          resp.json()
          Swal.fire(
            'New Admin Added',
            'You can login with the new admin accout',
            'success'
          )})
        .catch(console.log)
    }
  }

  export const loginAdmin = (loginInput) => {
    return (dispatch, getState) => {

      return fetch("https://aci-hardware.herokuapp.com/admin/login", {
        method: "POST",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          access_token: localStorage.getItem('access_token')
        },
        body: JSON.stringify(loginInput)
      })
    }
  }